import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IMobileSecuritySettingsResult extends IResult {
}

export interface IMobileSecuritySettings {
  jailbroken_device: IMobileSecuritySetting;
  screenshot: IMobileSecuritySetting;
  max_offline: IMobileSecuritySetting;
}

export interface IMobileSecuritySetting {
  enabled: boolean;
  key: string;
  androidConfig: IMobileSecurityConfig;
  iosConfig: IMobileSecurityConfig;
}

export interface IMobileSecurityConfig {
  enabled: boolean;
  severity: IMobileSecuritySeverityLevel;
  value: string;
}

export enum IMobileSecuritySeverityLevel {
  CRITICAL = 'critical',
  ERROR = 'error',
  WARN = 'warn'
}

export enum IMobileOS {
  ANDROID = 'android',
  IOS = 'ios'
}
